const MuiCheckbox = {
  styleOverrides: {
    root: {
      '&&:hover': {
        backgroundColor: 'transparent !important',
      },
    },
  },
};

export default MuiCheckbox;
